import Axios from 'axios'

export const mystique = Axios.create({
  baseURL: process.env.REACT_APP_ENV === 'prod' ? 'https://mystique.noodoe.com' : 'https://mystique-dev.noodoe.com',
  headers: {
    'X-API-KEY': process.env.REACT_APP_ENV === 'prod' ? '6cd549bf-5181-4ade-9ad9-8c35851800df' : '2b0d1441-eaae-4d20-a88d-9a500980a74d',
  }
})

export const nex = Axios.create({
  baseURL: process.env.REACT_APP_ENV === 'prod' ? 'https://nex.noodoe.com' : 'https://nex-dev.noodoe.com',
})

export const firmware = Axios.create({
  baseURL: process.env.REACT_APP_ENV === 'prod' ? 'xxxxxx' : 'https://firmware-nex-dev.noodoe.com',
})


// WEBPACK FOOTER //
// ./src/lib/api.js